import {Api} from '../../../Api.js'

const RESOURCE = 'brand'

export default {
    resource: RESOURCE,
    prefix: 'shop/',
    all(query) {
        return Api().get( this.prefix + this.resource + '/all')
    },
    query(query) {
        return Api().get(this.prefix + this.resource + (query ? query : ''))
    },
    get(id) {
        return Api().get(this.prefix + this.resource + '/' + id)
    },
    create(data) {
        return Api().post(this.prefix + this.resource, data)
    },
    update(id, data) {
        return Api().put(this.prefix + this.resource + '/' + id, data)
    },
    delete(id) {
        return Api().delete(this.prefix + this.resource + '/' + id)
    },
    import(data) {
        return Api().post(this.prefix + this.resource + '/import', data)
    },
}


// WEBPACK FOOTER //
// ./src/modules/shop/brand/BrandService.js